export enum ENUM__error_type {
  UNKNOWN = 'base.unknown',
  NOT_IMPLEMENTED = 'base.not_implemented',
  RESPONSE_TIMEOUT = 'response_timeout',
  FEATURE_DISABLED = 'feature.disabled',
  TOO_MANY_REQUESTS = 'too_many_requests',
  REQUEST_ALREADY_PROCESSED = 'request_already_processed',
  WRONG_CASE = 'wrong_case',
  MUTEX_ALREADY_LOCKED = 'mutex_already_locked',
  SOCKETIO_CONNECTION_CLOSED = 'socketio_connection_closed',
  /*
   * APP
   */

  APP_SHUTDOWN_IN_PROGRESS = 'app_shutdown_in_progress',
  APP_MAINTENANCE_MODE_ENABLED = 'app_maintenance_mode_enabled',

  /*
   * AUTH
   */

  AUTH_SOCIAL_NETWORK_ALREADY_LINKED_TO_SOME_USER = 'auth.social_network_already_linked_to_some_user',

  AUTH_CREDENTIALS_ARE_EMPTY = 'auth.credentials_are_empty',
  AUTH_USER_NOT_FOUND = 'auth.user_not_found',
  AUTH_INVALID_PASSWORD = 'auth.invalid_password',
  AUTH_MAGIC_LINK_IS_NOT_VALID = 'auth.magic_link_is_not_valid',
  AUTH_EMAIL_IS_NOT_VERIFIED = 'auth.email_is_not_verified',
  AUTH_EMAIL_VERIFICATION_TOKEN_IS_INVALID = 'auth.email_verification_token_is_invalid',
  AUTH_CANNOT_UNLINK_LAST_PROVIDER = 'auth.cannot_unlink_last_provider',

  EMAIL_IS_NOT_EMAIL = 'email_is_not_email',
  EMAIL_INSIDE_CATCH_ALL_DOMAIN = 'email_inside_catch_all_domain',
  EMAIL_IS_SPAMTRAP = 'email_is_spamtrap',
  EMAIL_IS_ABUSE = 'email_is_abuse',
  EMAIL_IS_DO_NOT_MAIL = 'email_is_do_not_mail',
  EMAIL_CANT_BE_VERIFIED = 'email_cant_be_verified',
  EMAIL_DOES_NOT_ACCEPT_MAIL = 'email_does_not_accept_mail',
  EMAIL_FAILED_SYNTAX_CHECK = 'email_failed_syntax_check',
  EMAIL_HAS_POSSIBLE_TYPO = 'email_has_possible_typo',
  EMAIL_MAILBOX_NOT_FOUND = 'email_mailbox_not_found',
  EMAIL_NO_DNS_ENTRIES = 'email_no_dns_entries',
  EMAIL_MAILBOX_IS_FULL = 'email_mailbox_is_full',
  EMAIL_UNROUTABLE_IP_ADDRESS = 'email_unroutable_ip_address',
  EMAIL_ANTISPAM = 'email_antispam',
  EMAIL_VALIDATION_FAILED_WITH_EXCEPTION = 'email_validation_failed_with_exception',
  EMAIL_FAILED_SMTP_CONNECTION = 'email_failed_smtp_connection',
  EMAIL_FORCIBLE_DISCONNECT = 'email_forcible_disconnect',
  EMAIL_GREYLISTED = 'email_greylisted',
  EMAIL_SERVER_DID_NOT_RESPOND = 'email_server_did_not_respond',
  EMAIL_SERVER_TEMPORARY_ERROR = 'email_server_temporary_error',
  EMAIL_TIMEOUT_EXCEEDED = 'email_timeout_exceeded',
  EMAIL_GLOBAL_SUPRESSION = 'email_global_suppression',
  EMAIL_POSSIBLE_TRAP = 'email_possible_trap',
  EMAIL_ROLE_BASED = 'email_role_based',
  EMAIL_ROLE_BASED_CATCH_ALL = 'email_role_based_catch_all',
  EMAIL_IS_TEMPORARY = 'email_is_temporary',
  EMAIL_IS_TOXIC = 'email_is_toxic',

  EMAIL_IS_INVALID = 'email_is_invalid',
  EMAIL_VALIDATION_FAILED = 'email_validation_failed',

  /*
   * CREDITS
   */
  USING_GUARANTEED_CREDITS_NOT_ALLOWED = 'using_guaranteed_credits_not_allowed',

  /*
   * GENERATION
   */

  GENERATION_ALREADY_IN_PROGRESS = 'generation.already_in_progress',
  GENERATION_ALREADY_FINISHED = 'generation.already_finished',
  GENERATION_CANT_AUTORUN_NODES = 'generation.cant_autorun_nodes',

  GENERATION_WRONG_STATUS = 'generation.wrong_status',
  GENERATION_TOKEN_IS_GRID2D_DIMENSION = 'generation.token_is_grid2d_dimension',

  GENERATON_CANT_DELETE_LAST_SEED = 'generation_cant_delete_last_seed',

  /*
   * MODEL
   */

  ML_ASSET_RESERVATION_REQUIRED = 'ml_asset_reservation.required',
  ML_ASSET_RESERVATION_EXPIRED = 'ml_asset_reservation.expired',

  /*
   * HTTP
   */
  HTTTP_INVALID_RESPONSE = 'http_invalid_response',
  HTTP_FETCH_FAILED = 'http.fetch_failed',

  /*
   * STRING
   */

  STRING_SHOULD_BE_EMPTY = 'string_should_be_empty',
  STRING_CANT_BE_EMPTY = 'string_cant_be_empty',
  STRING_CANT_BE_BLANK = 'string_cant_be_blank',
  STRING_NOTHING_TO_TRANSLATE = 'string_nothing_to_translate',

  /*
   * ARRAY
   */

  ARRAY_CANT_BE_EMPTY = 'array_cant_be_empty',
  ARRAY_SHOULD_CONTAINS_ONE_ITEM = 'array_should_contains_one_item',
  ARRAY_SIZE_MISMATCH = 'array_size_mismatch',

  /*
   * MAP
   */

  MAP_CANT_BE_EMPTY = 'map_cant_be_empty',

  /*
   * NUMBER
   */

  NUMBER_NOT_IN_RANGE = 'number_not_in_range',
  VALIDATION_INVALID_NUMBER = 'validation.validation_invalid_number',

  /*
   * OBJECT
   */
  OBJECT_CANT_BE_STUB = 'OBJECT_CANT_BE_STUB',

  /*
   * NULL
   */

  VALUE_CANT_BE_NULL = 'value_cant_be_null',
  VALUE_SHOULD_BE_NULL = 'value_should_be_null',

  VALIDATION_INVALID_TYPE = 'validation.validation_invalid_type',
  VALIDATION_INVALID_VALUE = 'validation.validation_invalid_value',
  VALIDATION_RECEIVED_DATA_IS_WRONG = 'validation.received_data_is_wrong',

  /*
   * ID
   */
  INVALID_ID = 'invalid_id',

  /*
   * ITEM IN COLLECTION
   */

  //todo= Tkach replace error
  VALIDATION_ITEM_NOT_FOUND = 'validation.validation_item_not_found',
  //todo= Tkach replace error
  VALIDATION_ITEM_ALREADY_EXISTS = 'validation.validation_item_already_exists', //?

  /*
   * LLM
   */

  // 'No descriptions to generate'
  LLM_GENERATION_FAILED = 'llm.generation_failed',
  LLM_PROMPT_NOT_FOUND = 'llm.prompt_not_found',
  LLM_NO_DESCRIPTIONS = 'llm.no_descriptions',

  /*
   * FILES
   */

  FILE_INVALID_SIZE = 'file.invalid_size',
  FILE_INVALID_TYPE = 'file.invalid_type',
  FILE_NOT_FOUND = 'file.not_found',

  /*
   * IMAGE
   */
  IMAGE_WRONG_SIZE = 'IMAGE_WRONG_SIZE',
  IMAGE_WRONG_ASPECT_RATIO = 'IMAGE_WRONG_ASPECT_RATIO',

  /*
   * SERIALIZATION
   */

  SERIALIZATION_CLASS_NOT_FOUND = 'serialization.class_not_found',
  SERIALIZATION_CLASSNAME_IS_EMPTY = 'serialization.classname_is_empty',

  /*
   * REQUESTS
   */
  RESPONSE_GENERATOR_TO_SERVER_FAILED = 'response_generator_to_server_failed',

  /*
   * USER
   */

  USER_ACCESS_DENIED = 'user_access_denied',

  /*
   * WORKSPACE
   */

  WORKSPACE_CANT_DELETE_INVITATION_BY_LINK = 'workspace_cant_delete_invitation_by_link',

  WORKSPACE_SHARED_ENTITY_NOT_FOUND = 'workspace_shared_entity_not_found',

  WORKSPACE_ENTITY_ALREADY_DELETED = 'workspace_entity_already_deleted',
  WORKSPACE_INVALID_INVITE_TOKEN = 'workspace_invalid_invite_token',

  WORKSPACE_ACCESS_DENIED = 'workspace_access_denied',

  WORKSPACE_USER_ALREADY_INVITED = 'workspace_user_already_invited',
  WORKSPACE_USER_ALREADY_IS_MEMBER = 'workspace_user_is_already_member',

  WORKSPACE_INVITATION_TOKEN_ALREADY_USED = 'workspace_invitation_token_already_used',

  WORKSPACE_TRANSFER_OWNERSHIP_ALREADY_INITIATED = 'workspace_transfer_ownership.already_initiated',
  WORKSPACE_LIMIT_REACHED = 'workspace_limit_reached',
  WORKSPACE_USER_NOT_FOUND = 'workspace_user_not_found',
  WORKSPACE_IS_SHARED = 'workspace_is_shared',
  WORKSPACE_IS_PERSONAL = 'workspace_is_personal',
  WORKSPACE_ACTION_IS_NOT_ALLOWED_FOR_OWNER = 'workspace_action_is_not_allowed_for_owner',

  /*
   * GENERATOR
   */
  GENERATOR_ACCESS_DENIED = 'generator_access_denied',
  GENERATOR_ALREADY_AUTHORIZED = 'generator_already_authorized',
  GENERATOR_IS_NOT_AUTHORIZED = 'generator.is_not_authorized',
  GENERATOR_MASTER_IS_NOT_ACTIVATED_ON_ANY_VPS = 'generator.master_is_not_activated_on_any_vps',
  GENERATOR_CANT_LAUNCH_VPS = 'generator.cant_launch_vps',

  GRAPH_EDGE__NODE_FROM_NOT_FOUND = 'GRAPH_EDGE__NODE_FROM_NOT_FOUND',
  GRAPH_EDGE__NODE_TO_NOT_FOUND = 'GRAPH_EDGE__NODE_TO_NOT_FOUND',
  GRAPH_EDGE__ALREADY_EXISTS = 'GRAPH_EDGE__ALREADY_EXISTS',
  GRAPH_EDGE__DUPLICATE = 'GRAPH_EDGE__DUPLICATE',

  GRAPH_NODE__CONNECTED_TO_NODE_WITH_ERROR = 'GRAPH_NODE__CONNECTED_TO_NODE_WITH_ERROR',
  GRAPH_NODE__CONTAINS_FIELDS_WITH_ERRORS = 'GRAPH_NODE__CONTAINS_FIELDS_WITH_ERRORS',

  GRAPH_NODE__NODE_NOT_FOUND = 'GRAPH_NODE__NODE_NOT_FOUND',
  GRAPH_NODE__ALREADY_EXISTS = 'GRAPH_NODE__ALREADY_EXISTS',
  GRAPH_NODE__CANT_BE_STUB = 'GRAPH_NODE__CANT_BE_STUB',
  GRAPH_NODE__DUPLICATE_ID = 'GRAPH_NODE__DUPLICATE_ID',
  GRAPH_NODE__DUPLICATE_ROLE = 'GRAPH_NODE__DUPLICATE_ROLE',

  /*
   *
   */
  GRAPH_FIELD__DUPLICATE_ROLE = 'GRAPH_FIELD__DUPLICATE_ROLE',

  GRAPH_FIELD__MULTIPLE_ENABLED_INCOMING_EDGES_ARE_NOT_ALLOWED = 'GRAPH_FIELD__MULTIPLE_ENABLED_INCOMING_EDGES_ARE_NOT_ALLOWED',

  GRAPH_FIELD__NON_INITIALIZED_FIELD_CONNECTED_TO_OTHER = 'GRAPH_FIELD__NON_INITIALIZED_FIELD_CONNECTED_TO_OTHER',

  GRAPH_FIELD__MISSING_CONNECTION = 'GRAPH_FIELD__MISSING_CONNECTION',
  GRAPH_FIELD__OUTPUT_CANT_BE_OPTIONAL = 'GRAPH_FIELD__OUTPUT_CANT_BE_OPTIONAL',
  GRAPH_FIELD__DUPLICATE_ID = 'GRAPH_FIELD__DUPLICATE_ID',
  GRAPH_FIELD__OUTPUT_CANT_BE_DIMENSION = 'GRAPH_FIELD__OUTPUT_CANT_BE_DIMENSION',
  GRAPH_FIELD__LINKED_FIELD_CANT_BE_DIMENSION = 'GRAPH_FIELD__LINKED_FIELD_CANT_BE_DIMENSION',

  GRAPH_FIELD_NUMBER__VALUE_RANGE_IS_STUB = 'GRAPH_FIELD_NUMBER__VALUE_RANGE_IS_STUB',
  GRAPH_FIELD_NUMBER__VALUES_ALLOWED_IS_STUB = 'GRAPH_FIELD_NUMBER__VALUES_ALLOWED_IS_STUB',
  GRAPH_FIELD_NUMBER__SLIDER_STEPS_ARE_EMPTY = 'GRAPH_FIELD_NUMBER__SLIDER_STEPS_ARE_EMPTY',

  GRAPH_FIELD_SEED__VALUE_RANGE_IS_EMPTY = 'GRAPH_FIELD_SEED__VALUE_RANGE_IS_EMPTY',

  GRAPH_FIELD__VALUE_CANT_BE_NULL = 'GRAPH_FIELD__VALUE_CANT_BE_NULL',
  GRAPH_FIELD__VALUE_RANGE_CANT_BE_NULL = 'GRAPH_FIELD__VALUE_RANGE_CANT_BE_NULL',
  GRAPH_FIELD__VALUES_ALLOWED_CANT_BE_NULL = 'GRAPH_FIELD__VALUES_ALLOWED_CANT_BE_NULL',

  GRAPH_FIELD_PRIMITIVE__WRONG_VALUE = 'GRAPH_FIELD_PRIMITIVE__WRONG_VALUE',
  GRAPH_FIELD_PRIMITIVE__WRONG_VALUE_RANGE = 'GRAPH_FIELD_PRIMITIVE__WRONG_VALUE_RANGE',

  GRAPH_FIELD_IMAGE__CROP_BOX_IS_EMPTY = 'GRAPH_FIELD_IMAGE__CROP_BOX_IS_EMPTY',
  GRAPH_FIELD_IMAGE__IMAGE_IS_EMPTY = 'GRAPH_FIELD_IMAGE__IMAGE_IS_EMPTY',
  GRAPH_FIELD_IMAGE__IMAGE_SOURCE_IS_EMPTY = 'GRAPH_FIELD_IMAGE__IMAGE_SOURCE_IS_EMPTY',
  GRAPH_FIELD_IMAGE__IMAGE_MASK_IS_EMPTY = 'GRAPH_FIELD_IMAGE__IMAGE_MASK_IS_EMPTY',

  GRAPH_FIELD_IMAGE__CROP_BOX_WRONG_SIZE = 'GRAPH_FIELD_IMAGE__CROP_BOX_WRONG_SIZE',

  GRAPH__MISSING_GRID2D_IMAGE_OUT = 'GRAPH__MISSING_GRID2D_IMAGE_OUT',
  GRAPH__MISSING_GRID2D_ROW = 'GRAPH__MISSING_GRID2D_ROW',
  GRAPH__MISSING_GRID2D_COLUMN = 'GRAPH__MISSING_GRID2D_COLUMN',
  GRAPH__IS_CYCLIC = 'GRAPH__IS_CYCLIC',

  GRAPH_NODE_DENOISE__LATENTS_REQUIRED = 'GRAPH_NODE_DENOISE__LATENTS_REQUIRED',
}
